import { createHashRouter, createRoutesFromElements, Route } from 'react-router';

import AppLayout from '@/features/app/AppLayout';
import DemoFleetPlayerPage from '@/features/demofleet-player/DemoFleetPlayerPage';

export const DEFAULT_ROUTE = '/';

export const router = createHashRouter(
    createRoutesFromElements(
        <Route path="/" element={<AppLayout />}>
            <Route index element={<DemoFleetPlayerPage />} />
        </Route>,
    ),
);
